import { Inject, Injectable } from '@angular/core'
import { HttpClient, HttpParams } from '@angular/common/http'
import { UnespCoreEnvironment } from 'src/libs/unesp-core'
import { identity, Observable } from 'rxjs'
import { ErrorHandlerService } from './error-handler.service'
import { GestaoUsuario } from '../models/gestao-usuario'

@Injectable({ providedIn: 'root' })
export class GestaoUsuarioService {
  private baseUrl: string

  constructor(
    private http: HttpClient,
    private errorHandlerService: ErrorHandlerService,
    @Inject('environment') env: UnespCoreEnvironment
  ) {
    this.baseUrl = env.baseUrlApi
  }

  verificarAcesso(): Observable<boolean> {
    return this.http.get<boolean>(`${this.baseUrl}/gestao-usuario/verificar-acesso`)
      .pipe(identity, this.errorHandlerService.catchError())
  }

  contarAdmins(codigoUnidadePrefix: string): Observable<number> {
    return this.http.get<number>(`${this.baseUrl}/gestao-usuario/contagem-admins/${codigoUnidadePrefix}`)
      .pipe(identity, this.errorHandlerService.catchError())
  }

  buscarUsuario(username: string): Observable<any> {
    return this.http.get<any>(`${this.baseUrl}/gestao-usuario/buscar-usuario`, {
      params: new HttpParams().set('username', username)
    }).pipe(identity, this.errorHandlerService.catchError())
  }

  listar(search = '', papel = '', codigoUnidade = '', sigla = '', page = 0, size = 10, sortField = 'nome', sortDirection = 'asc'): Observable<any> {
    let params = new HttpParams()
      .set('search', search)
      .set('page', page.toString())
      .set('size', size.toString())
      .set('sortField', sortField)
      .set('sortDirection', sortDirection)
    if (papel) params = params.set('papel', papel)
    if (codigoUnidade) params = params.set('codigoUnidade', codigoUnidade)
    if (sigla) params = params.set('sigla', sigla)
    return this.http.get<any>(`${this.baseUrl}/gestao-usuario/usuario`, { params })
      .pipe(identity, this.errorHandlerService.catchError())
  }

  getByUsername(username: string): Observable<GestaoUsuario> {
    return this.http.get<GestaoUsuario>(`${this.baseUrl}/gestao-usuario/usuario/${username}`)
      .pipe(identity, this.errorHandlerService.catchError())
  }

  criar(username: string, email: string, codigoUnidade: string, matricula: string, nome: string, papel: string): Observable<GestaoUsuario> {
    const params = new HttpParams()
      .set('username', username)
      .set('email', email)
      .set('codigoUnidade', codigoUnidade)
      .set('matricula', matricula)
      .set('nome', nome)
      .set('papel', papel)
    return this.http.post<GestaoUsuario>(`${this.baseUrl}/gestao-usuario/usuario`, null, { params })
      .pipe(identity, this.errorHandlerService.catchError())
  }

  atualizar(username: string, email: string, codigoUnidade: string, matricula: string, nome: string): Observable<GestaoUsuario> {
    let params = new HttpParams()
    if (email) params = params.set('email', email)
    if (codigoUnidade) params = params.set('codigoUnidade', codigoUnidade)
    if (matricula) params = params.set('matricula', matricula)
    if (nome) params = params.set('nome', nome)
    return this.http.put<GestaoUsuario>(`${this.baseUrl}/gestao-usuario/usuario/${username}`, null, { params })
      .pipe(identity, this.errorHandlerService.catchError())
  }

  adicionarPapel(username: string, papel: string): Observable<void> {
    const params = new HttpParams().set('username', username).set('papel', papel)
    return this.http.put<void>(`${this.baseUrl}/gestao-usuario/permissao`, null, { params })
      .pipe(identity, this.errorHandlerService.catchError())
  }

  removerPapel(username: string, papel: string): Observable<void> {
    const params = new HttpParams().set('username', username).set('papel', papel)
    return this.http.delete<void>(`${this.baseUrl}/gestao-usuario/permissao`, { params })
      .pipe(identity, this.errorHandlerService.catchError())
  }
}
